import App from './App.svelte';
import './global.css';

Telegram.WebApp.ready();

const app = new App({
  target: document.body
});

export default app;
